import React, { useState, useEffect, useRef } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import UpdatePasswordModal from "./UpdatePasswordModal";
import { Toast } from "primereact/toast";
import SettingService from "../SettingService";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import moment from 'moment-timezone';
import { RadioButton } from "primereact/radiobutton";
const UserDetails = () => {
  const toast = useRef<any>(null);
  const { t } = useTranslation();

  const settingService = new SettingService();

  const [email, setEmail] = useState<any>("lorem@ipsum.com");
  const [language, setLanguage] = useState<any>({});
  const [timezone, setTimeZone] = useState<any>({});
  const [weather, setWeather] = useState<any>({});
  const [isUpdatePassword, setIsUpdatePassword] = useState<boolean>(false);

  const languages = [
    { name: "German", value: "de" },
    { name: "English", value: "en" },
  ];

  const timezones: any = [
    { name: "Europe/Berlin", value: "Europe/Berlin" },
    { name: "Europe/Athens", value: "Europe/Athens" },
    {name: "Europe/London", value: "Europe/London"},
    { name: "UTC Time", value: "UTC" },

  ];


  const showSuccess = (message: string) => {
    toast.current.show({
      severity: "success",
      summary: "Confirmation Message",
      detail: message,
      life: 3000,
    });
  };

  const checkDST = ()=>{
    const date = new Date('2023-10-18T12:00:00');
    const timeZ = "Europe/Berlin"
    const m = moment.tz(date, timeZ);
    return m.isDST();
  }
  const saveSettings = () => {
    i18n.changeLanguage(language);
    localStorage.setItem("lang", language);
    localStorage.setItem("timezone", timezone);
    const isDST = moment.tz(timezone).isDST();
    if(isDST)
      setWeather("Summer")
    else
      setWeather("Winter")
    const data = {
      language: language,
      timezone: timezone,
    };
    settingService.updateUserSettings(email, data).then((response) => {
      if (response === 200) {
        showSuccess(t('setting_updated'));
      }
    });
  };


  useEffect(() => {
    const timeZone: string = localStorage.getItem('timezone')!;
    const isDST = moment.tz(timeZone).isDST();
    if(isDST)
      setWeather("Summer")
    else
      setWeather("Winter")
    settingService.getUserDetails().then((response) => {
      setEmail(response["email"]);
      const language = response["language"].trim();
      setLanguage(language);
      setTimeZone(response["timezone"]);

    });
  }, [i18n.language]);
  return (
    <>
      <Card title={t("user_details")} className="InputForms_container mt-4">
        <div>
          <Toast ref={toast} />

          <div className="grid align-items-center mb-4">
            <div className="col-12 lg:col-2">
              <h5 className="mb-2">{t("user_email")}</h5>
            </div>
            <div className="col-6 lg:col-4">
              <InputText
                className="p-inputtext-sm block mb-0 ml-5"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled
              />
            </div>
            <div className="col-6 lg:col-4">
              <Button
                label={t("update_password")}
                className="p-button-outlined ml-8"
                onClick={() => setIsUpdatePassword(true)}
              />
            </div>
          </div>

          {isUpdatePassword ? (
            <>
              <UpdatePasswordModal
                modal={isUpdatePassword}
                hidePopup={() => {
                  setIsUpdatePassword(false);
                }}
                showSuccess={() => {
                  showSuccess("The password has been updated!");
                }}
              />
            </>
          ) : (
            <></>
          )}

          <div className="grid align-items-center mb-4">
            <div className="col-12 lg:col-2">
              <h5 className="mb-2">{t("language_setting")}</h5>
            </div>
            <div className="col-6 lg:col-4 ml-5">
              <Dropdown
                value={language}
                options={languages}
                onChange={(e) => setLanguage(e.value)}
                optionLabel="name"
                placeholder="Select a language"
              />
            </div>
          </div>

          <div className="grid align-items-center mb-4">
            <div className="col-12 lg:col-2">
              <h5 className="mb-2">{t("timezone")}</h5>
            </div>
            <div className="col-6 lg:col-4 ml-5">
              <Dropdown
                value={timezone}
                options={timezones}
                onChange={(e) => setTimeZone(e.value)}
                optionLabel="name"
                placeholder="Server Account Timezone"
              />
            </div>
          </div>

          <div className="grid align-items-center mb-4">
            <div className="col-12 lg:col-2">
              <h5 className="mb-2">{t("summer_winter")}</h5>
            </div>

            <div className="col-6 lg:col-4 ml-5">
              <RadioButton inputId="weather" name="pizza" value="Summer" onChange={(e) => setWeather(e.value)} checked={weather === 'Summer'} disabled/>
              <label htmlFor="weather" className="ml-2">Summer</label>
              <RadioButton className="ml-3" inputId="weather1" name="pizza" value="Winter" onChange={(e) => setWeather(e.value)} checked={weather === 'Winter'} disabled/>
              <label htmlFor="weather1" className="ml-2">Winter</label>
              {/*<Dropdown*/}
              {/*  value={weather}*/}
              {/*  options={weathers}*/}
              {/*  onChange={(e) => setWeather(e.value)}*/}
              {/*  optionLabel="name"*/}
              {/*  placeholder="Server Account Summer/Winter Time"*/}
              {/*/>*/}

            </div>
          </div>

          <div className="flex flex-wrap align-items-center justify-content-center lg:justify-content-between">
            <p className="text-danger text-underline"></p>
            <p className="text-danger"></p>
            <div>
              <Button
                icon="pi pi-save"
                label={t("save_user_settings")}
                className="p-button-outlined p-button-secondary ml-2"
                iconPos="left"
                onClick={saveSettings}
              />
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default UserDetails;
